module.exports = __webpack_public_path__ + "assets/img/102003.429c671b.png";